import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import ButtonWithBG from "../../Components/UI/ButtonMain";
import "react-datepicker/dist/react-datepicker.css";
import { ADD_LEDGER } from "../../Utils/ApiGlobal";
import axiosInstance from "../../Utils/API";
import Loader from "../../Components/UI/Loader";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { LedgerTypesOptions } from "../../Utils/Constants";
import SearchVelicleOwner from "../../Components/Functionality/SearchVelicleOwner";
import CompanyInformation from "../../Components/Functionality/CompanyInformation";
import { ConfirormationModal } from "../../Components/UI/ConfirormationModal";
import moment from "moment";
import BankDetails from "../../Components/Functionality/BankDetails";

const Input = (props) => (
  <input
    className="peer w-full px-3 py-2  border border-gray-300 placeholder-gray-500  rounded-md focus:outline-none  focus:z-10 sm:text-sm "
    {...props}
  />
);
const Label = (props) => (
  <p className="flex flex-row text-gray-700 text-sm font-medium text-slate-700 mb-1">
    {props.label}
    {props.isRequired === "true" && (
      <>
        {" "}
        <span className="ml-1 text-red-500 block text-sm font-medium ">*</span>
      </>
    )}
  </p>
);

export default function AddEditLedger(props) {
  let [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [amountType, setAmountType] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleOwnerId, setVehicleOwnerId] = useState();
  const [comapnyId, setComapanyId] = useState();
  const [ledgerType, setLedgerType] = useState();
  const [bankBranch, setBankBranch] = useState();
  const [bankAcc, setBankAcc] = useState();
  const openModal = () => {
    setIsOpen(true);
  };
  useEffect(() => {
    // console.log(props, "data for company name");
    // StatusValue();
  });
  // Form values into spread objects
  const formValueConvertor = (formObj) => ({
    ...formObj,
  });

  const getFormJSON = (form) => {
    const data = new FormData(form);
    return Array.from(data.keys()).reduce((result, key) => {
      var value = data.get(key);
      if (value) result[key] = value;
      result[key] = value || " ";
      return result;
    }, {});
  };
  //   Form submit click event
  const ledgerForm = (ev) => {
    ev.preventDefault();
    setIsLoading(true);
    var obj = formValueConvertor(getFormJSON(ev.target));
    let ADD_LEDGER_DATA = {
      Date: moment(startDate).toDate(),
      PaymentType: amountType,
      Amount: obj.amount,
      LedgerType: ledgerType,
      VehicleOwnerId: vehicleOwnerId,
      CompanyId: comapnyId,
      Note: obj.note.toUpperCase(),
      BankBranchName:bankBranch,
      BankAccountNo:bankAcc,
      CreatedBy: localStorage.getItem("userId"),
    };
    axiosInstance
      .post(ADD_LEDGER, ADD_LEDGER_DATA)
      .then((response) => {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        if (response.data.data.message) {
          ConfirormationModal(response.data.data.message, "success", 2000);
        }
        setIsLoading(false);
        props.getAPI(props.dependency.ledgerType, props.dependency.bankBranch)
      })
      .catch((error) => {
        ConfirormationModal(error.message, "error", 2000);
      });
  };
  const onAmountType = (event) => {
    // console.log(event.target.value);
    setAmountType(event.target.value);
  };
  const handleButtonClick = (action) => {
    // handle all the action in the main view
    setIsOpen(false);
    // [] should be passing info
    // handleClose({ action });
  };
  return (
    <>
      <div>
        <div className="flex justify-end">
          <ButtonWithBG
            handleClick={openModal}
            theme="primary"
            label="Add Ledger"
          />
        </div>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed w-full inset-0 z-30  flex justify-center  items-center bg-white bg-opacity-75 rounded-lg shadow-md"
            open={isOpen}
            onClose={() => setIsOpen(false)}
          >
            <div className="w-full ml-4 px-4 text-center">
              <Dialog.Overlay className="	 fixed  inset-0" />
              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <div className="border-2 w-8/12	 border-gray-500 inline-block  pt-6 text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                {isLoading === true ? (
                  <div className=" px-6 pt-6 w-full pb-6 h-64">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <Dialog.Title
                      as="h3"
                      className="text-lg  font-medium leading-6 text-center text-gray-900 "
                    >
                      <p>Add Ledger</p>
                    </Dialog.Title>
                    <form
                      onSubmit={ledgerForm}
                      className=" px-6 pt-6 w-full pb-6"
                    >
                      <div className="space-y-4 ">
                        <div className="flex flex-row space-x-4">
                          <div className="flex flex-col w-1/2 text-left ">
                            <Label label="Date" isRequired="true" />
                            <DatePicker
                              dateFormat="dd-MM-yyy"
                              className="peer  w-full px-3 py-2  border border-gray-300 placeholder-gray-500  rounded-md focus:outline-none  focus:z-10 sm:text-sm "
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              name="ledgerDate"
                            />
                          </div>
                          <div className="flex flex-col w-1/2	text-left ">
                            <Label label="Type of Amount" isRequired="true" />
                            <div
                              className="space-x-8 w-full"
                              onChange={onAmountType}
                            >
                              <input
                                type="radio"
                                className="form-radio text-primary-kirtiroadways focus:ring-primary-kirtiroadways dark:focus:ring-primary-kirtiroadways dark:ring-offset-gray-800 focus:ring-2 dark:bg-primary-kirtiroadways dark:border-gray-600"
                                value="Credit"
                                name="TypeOfAmount"
                              />
                              {"   "}
                              Credit
                              <input
                                type="radio"
                                className="form-radio text-primary-kirtiroadways focus:ring-primary-kirtiroadways dark:focus:ring-primary-kirtiroadways dark:ring-offset-gray-800 focus:ring-2 dark:bg-primary-kirtiroadways dark:border-gray-600"
                                value="Debit"
                                name="TypeOfAmount"
                              />
                              {"   "}
                              Debit
                            </div>
                          </div>
                          <div className="flex flex-col w-1/2 text-left">
                            <Label label="Bank Branch" isRequired="true" />
                            <BankDetails
                              defaultValue=""
                              handleOnChange={(e) => {
                                setBankBranch(e.label)
                                setBankAcc(e.value)
                              }}
                            />
                          </div>
                        </div>

                        <div className="flex flex-row space-x-2 w-full text-left">
                          <div className="flex flex-col w-1/2 text-left">
                            <Label label="Amount" isRequired="true" />
                            <Input name="amount" placeholder="Amount" />
                          </div>
                          <div className="flex flex-col w-1/2 text-left">
                            <Label label="Ledger Type" isRequired="true" />
                            <Select
                              options={LedgerTypesOptions}
                              name="LedgerType"
                              onChange={(e) => {
                                setLedgerType(e.value);
                              }}
                              placeholder="Select Ledger Type"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#8cd7de",
                                  primary: "#179eaa",
                                },
                              })}
                            />
                          </div>
                          <div className="flex flex-col w-1/2 text-left">
                            <Label label="Vehicle Owner" isRequired="true" />
                            <SearchVelicleOwner
                              defaultValue=""
                              handleOnChange={(e) => {
                                setVehicleOwnerId(e.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex s h-24 space-x-2">
                          {ledgerType === "Booking" && (
                            <div className="flex flex-col w-1/2 text-left">
                              <Label label="Company Owner" isRequired="true" />
                              <CompanyInformation
                                defaultValue=""
                                handleOnChange={(e) => {
                                  setComapanyId(e.CompanyId);
                                }}
                              />
                            </div>
                          )}
                          <div className="flex flex-col md:w-full text-left">
                            <Label label="Note" />
                            <textarea
                              className="peer w-full px-3 py-2  border border-gray-300 placeholder-gray-500  rounded-md focus:outline-none  focus:z-10 sm:text-sm "
                              name="note"
                              id="note"
                              rows="2"
                              type="text"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      {/* Button */}
                      <div className=" mt-4 space-x-2 flex justify-center">
                        <ButtonWithBG
                          type="submit"
                          theme="primary"
                          label="Save"
                        />
                        <ButtonWithBG
                          handleClick={handleButtonClick}
                          theme="secondary"
                          label="Cancel"
                        />
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
}
